import { useBreakpoint } from '~/techstyle-shared/react-components';

const useMaxNumQuickFiltersToRender = () => {
  const { matches: isTablet } = useBreakpoint('tablet');
  const { matches: bp1512 } = useBreakpoint('(max-width: 1512px)');

  if (isTablet) {
    return 3;
  }

  if (bp1512) {
    return 5;
  }

  return 7;
};

export default useMaxNumQuickFiltersToRender;
